import { ISelectRetailerHelper } from './interfaces/SelectRetialHelper.interface';

export class SelectRetailerHelper implements ISelectRetailerHelper {
  public handleDropdown(onSelect: (id: number) => void): (event: any) =>  void {
    return (event: any): void => {
      onSelect(event.value);
    };
  }
}
